import React, { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import { PZH_CONTRACT } from '../../contracts/contractTypes';
import InvoicesForm from './InvoicesForm';
import { IdPropType } from '../../../proptypes/basic';
import LoadingBox from '../../loading/components/LoadingBox';
import TitleBar from '../../layout/components/TitleBar';
import { useMakeSelector } from '../../store/hooks';
import {
    makeContractsByCustomerIdSelector,
    useContractsByCustomerId,
} from '../../contracts/contractsSlice';

const Invoices = ({
    customerId,
    disabled
    }) => {
    const contracts = useMakeSelector(makeContractsByCustomerIdSelector, customerId);

    const pzhContracts = useMemo(
        () =>
            contracts
                .filter(({ type, parentContractId }) => type === PZH_CONTRACT && !parentContractId)
                // the still-active contract (no endAt, i.e. not cancelled) always comes
                // first - its startAt isn't necessarily the most recent one. Among
                // contracts that are equally active/inactive, newest startAt first.
                .sort((a, b) => {
                    if (!a.endAt && b.endAt) return -1;
                    if (a.endAt && !b.endAt) return 1;
                    return new Date(b.startAt) - new Date(a.startAt);
                }),
        [contracts]
    );

    const [, { loading, initialized }] = useContractsByCustomerId(customerId);
    // const [, { loading: invoicesLoading }] = useInvoicesByCustomerId(customerId);

    return (
        <>
            <TitleBar>PZH-Vertrag</TitleBar>
            <LoadingBox loading={loading || !initialized}>
                {pzhContracts.map((contract) => (
                    <InvoicesForm contractId={contract.id} key={contract.id} disabled={disabled} />
                ))}
                {pzhContracts.length === 0 && (
                    <Typography color="textSecondary">
                        Es existiert noch kein PZH Vertrag im CRM. Bitte über den Vertragstab
                        anlegen.
                    </Typography>
                )}
            </LoadingBox>
        </>
    );
};

Invoices.propTypes = {
    customerId: IdPropType.isRequired,
};

export default Invoices;
